import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ZoneItem } from "../../interfaces/lookup-tables/zone.model";
import { map, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class ZoneItemService {
  constructor(private http: HttpClient) {}

  getZoneItem(): Observable<{ items: ZoneItem[] }> {
    return this.http.get<{ items: ZoneItem[] }>('api/lookup/zone');
  }
}